export class FilterDemoDTO {
  name: string;
  description: string;
  characteristics: string;
  provider: string;
  priceFrom: string;
  priceTo: string;
  cpvId: string;
}
